/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import { TableRowActionButton } from './TableRowActionsSurface';
import { PermissionGate } from '../PermissionGate';
import { useTranslation } from '../../hooks/useTranslation';
import { DEFAULT_LANGUAGE, type SupportedLanguage } from '../../utils/language.utils';

export interface CrudActionButtonsPermissions {
  view?: string;
  edit?: string;
  copy?: string;
  delete?: string;
}

export interface CrudActionButtonsProps {
  language?: SupportedLanguage;
  permissions?: CrudActionButtonsPermissions;
  onView?: () => void;
  onEdit?: () => void;
  onCopy?: () => void;
  onDelete?: () => void;
  disableDelete?: boolean;
  viewTitle?: string;
  editTitle?: string;
  copyTitle?: string;
  deleteTitle?: string;
  /** Product actions retain their own permission and disabled-state checks. */
  customActions?: React.ReactNode;
}

export const CrudActionButtons: React.FC<CrudActionButtonsProps> = ({
  language = DEFAULT_LANGUAGE,
  permissions,
  onView,
  onEdit,
  onCopy,
  onDelete,
  disableDelete = false,
  viewTitle,
  editTitle,
  copyTitle,
  deleteTitle,
  customActions
}) => {
  const trans = useTranslation(language);
  const t = {
    view: viewTitle || trans.common.view,
    edit: editTitle || trans.common.edit,
    copy: copyTitle || trans.common.copy,
    delete: deleteTitle || trans.common.delete
  };

  const wrap = (permission: string | undefined, node: React.ReactNode) => {
    if (!permission) return <>{node}</>;
    return <PermissionGate permission={permission}>{node}</PermissionGate>;
  };

  return (
    <div className="action-buttons">
      {onView && wrap(permissions?.view, (
        <TableRowActionButton variant="view" icon="visibility" title={t.view} aria-label={t.view} onClick={onView} />
      ))}

      {onEdit && wrap(permissions?.edit, (
        <TableRowActionButton variant="edit" icon="edit" title={t.edit} aria-label={t.edit} onClick={onEdit} />
      ))}

      {onCopy && wrap(permissions?.copy, (
        <TableRowActionButton variant="copy" icon="copy" title={t.copy} aria-label={t.copy} onClick={onCopy} />
      ))}

      {onDelete && wrap(permissions?.delete, (
        <TableRowActionButton variant="delete" icon="delete" title={t.delete} aria-label={t.delete} onClick={onDelete} disabled={disableDelete} />
      ))}
      {customActions}
    </div>
  );
};
